import script from "./Clients.vue?vue&type=script&lang=ts&setup=true"
export * from "./Clients.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__